import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fallback"]
  static values = { liffId: String }

  async close() {
    try {
      if (window.liff && this.hasLiffIdValue) {
        await window.liff.init({ liffId: this.liffIdValue })
        if (window.liff.isInClient()) {
          window.liff.closeWindow()
          return
        }
      }
    } catch (_error) {
      // Keep the visible fallback below when LIFF cannot initialize.
    }

    if (!this.hasFallbackTarget) return

    this.fallbackTarget.hidden = false
    this.fallbackTarget.focus({ preventScroll: true })
  }
}
